import React from 'react';
import { SoundOutlined } from '@ant-design/icons';

const SoundIcon = () => <SoundOutlined style={{ fontSize: 32 }} />;

export default SoundIcon;
